import type { ReactNode } from 'react';
import { History } from 'lucide-react';
import { Accordion } from '@/components/ui';
import { purchaseEventText } from '@/utils/purchases';
import type { PurchaseEvent } from '@/types/api';

const time = (at: string) => new Date(at).toLocaleTimeString('ru-RU');

/**
 * A purchase's history (ADR-0053): what happened, when, by whom — written
 * whether anyone watched or not. Newest first, so a live one reads from the
 * top. Shown in the purchase wizard and in a site order's window (ADR-0059).
 */
export function PurchaseLog({ events, open, title = 'Ход покупки' }: { readonly events: readonly PurchaseEvent[]; readonly open: boolean; readonly title?: string }): ReactNode {
  if (events.length === 0) return null;
  return (
    <Accordion title={`${title} · ${events.length}`} icon={History} open={open}>
      <ol className="purchase-log" reversed>
        {[...events].reverse().map((event, index) => (
          <li key={`${event.at}-${index}`}>
            <time className="numeric muted" dateTime={event.at}>
              {time(event.at)}
            </time>
            <span>{purchaseEventText(event)}</span>
          </li>
        ))}
      </ol>
    </Accordion>
  );
}
